import { EProductType } from 'v2/interfaces/product';

const PRODUCT_TYPE_TITLES: Record<number, string> = {
  [EProductType.DIGITAL]: 'Digital',
  [EProductType.SERVICE]: 'Serviço online',
  [EProductType.PHYSICAL]: 'Produto físico',
  [EProductType.TICKET]: 'Eventos',
  [EProductType.SUBSCRIPTION]: 'Assinatura'
};

export function getProductTypeTitle(type: number): string {
  return PRODUCT_TYPE_TITLES[type] ?? 'Desconhecido';
}
